import React, { useContext } from "react";
import DescriptionInputField from "../../components/DescriptionInputField";
import InputFieldService from "../../components/InputFieldService";
import PriceInputSearchField from "../../components/PriceInputSearchField";
import "./CustomBillingSetup.scss";
import { ControlpanelContext } from "../../../util/context";
import CommonUtil from "../../../util/CommonUtils";


export default function CustomBillingSetup() {
    const { montlyBillingSetup,
        setMontlyBillingSetup,
        yearlyBillingSetup,
        setYearlyBillingSetup,
        montlyBillingSetupError,
        yearlyBillingSetupError,
        setMontlyBillingSetupError,
        setYearlyBillingSetupError,
    } = useContext(ControlpanelContext)
    return (
        <div>
            <div className="billingContent">
                <div className="left-section-billing">
                    <div id="text-field">
                        <div className="label">Billing cycle</div>
                        <InputFieldService value="Monthly" showIcon={true} />
                    </div>
                    {/* <div id="text-field">
                        <div className="label">Billing Interval</div>
                        <InputFieldService value="01" showIcon={true} />
                    </div> */}
                    <div id="text-field">
                        <div className="label">Price<span style={{ color: "#FE5050" }}>*</span></div>
                        <PriceInputSearchField
                            value={montlyBillingSetup.price}
                            onChange={(v) => {

                                setMontlyBillingSetupError({ ...montlyBillingSetupError, price: "" })
                                setMontlyBillingSetup({ ...montlyBillingSetup, price: v })

                            }}
                            error={montlyBillingSetupError.price}
                            label={"Enter amount"} />
                    </div>
                    <div id="text-field">
                        <div className="label">Plan description<span style={{ color: "#FE5050" }}>*</span></div>
                        <DescriptionInputField
                            value={montlyBillingSetup.description}
                            onChange={(v) => {
                                setMontlyBillingSetupError({ ...montlyBillingSetupError, description: "" })
                                setMontlyBillingSetup({ ...montlyBillingSetup, description: v })
                            }}
                            error={montlyBillingSetupError.description}
                            label={"Type message"} />
                    </div>
                </div>

                <div className="vertical-lines"></div>

                <div className="right-section-billing" style={{ marginLeft: "20px" }}>
                    <div id="text-field">
                        <div className="label">Billing cycle</div>
                        <InputFieldService value="Yearly" showIcon={true} />
                    </div>
                    {/* <div id="text-field">
                        <div className="label">Billing Interval</div>
                        <InputFieldService value="12" showIcon={true} />
                    </div> */}
                    <div id="text-field">
                        <div className="label">Price
                            <span style={{ color: "#FE5050" }}>*</span>
                            <span style={{marginLeft:"10px"}}>Average month price is 
                                <span style={{marginLeft:"10px",fontWeight: "bold",
                                color: (montlyBillingSetupError.price !=="" && !CommonUtil.isEmpty(montlyBillingSetup.price)) && "#FE5050"
                                }}>${(yearlyBillingSetup.price /12).toFixed(2)}</span></span>
                        </div>
                        <PriceInputSearchField
                            value={yearlyBillingSetup.price}
                            onChange={(v) => {
                                setYearlyBillingSetupError({ ...yearlyBillingSetupError, price: "" })
                                setYearlyBillingSetup({ ...yearlyBillingSetup, price: v })
                                setMontlyBillingSetupError({ ...montlyBillingSetupError, price: "" })
                            }}
                            error={yearlyBillingSetupError.price}
                            label={"Enter amount"} />
                    </div>
                    <div id="text-field">
                        <div className="label">Plan description<span style={{ color: "#FE5050" }}>*</span></div>
                        <DescriptionInputField
                            value={yearlyBillingSetup.description}
                            onChange={(v) => {
                                setYearlyBillingSetupError({ ...yearlyBillingSetupError, description: "" })
                                setYearlyBillingSetup({ ...yearlyBillingSetup, description: v })
                            }}
                            error={yearlyBillingSetupError.description}
                            label={"Type message"} />
                    </div>
                </div>
            </div>
        </div>
    );
}
